import { supabase } from '@/lib/supabase';
import { AuditLogRecord, PaginatedResult } from '@/types/models';
import { PAGE_SIZE } from '@/lib/constants';

export interface FetchAuditLogsParams {
  entityType?: string;
  action?: string;
  search?: string;
  page?: number;
}

export async function fetchAuditLogs(
  params: FetchAuditLogsParams
): Promise<PaginatedResult<AuditLogRecord>> {
  const { entityType = '', action = '', search = '', page = 0 } = params;
  const from = page * PAGE_SIZE;
  const to = from + PAGE_SIZE - 1;

  let query = supabase
    .from('audit_log')
    .select('*, changed_by_profile:profiles!audit_log_changed_by_fkey(id, full_name, role)', { count: 'exact' })
    .order('changed_at', { ascending: false })
    .range(from, to);

  if (entityType) query = query.eq('entity_type', entityType);
  if (action) query = query.eq('action', action);
  if (search.trim()) {
    const s = search.trim();
    query = query.or(`entity_type.ilike.%${s}%,action.ilike.%${s}%`);
  }

  const { data, error, count } = await query;
  if (error) throw error;

  return { data: (data ?? []) as AuditLogRecord[], count: count ?? 0 };
}
